// "use client";

import { create } from "zustand";

interface DialogState {
  isOpen: boolean;
  openDialog: () => void;
  closeDialog: () => void;
  children?: React.ReactNode;
  setChildren?: (children: React.ReactNode) => void;
  title?: string;
  description?: string;
  setContent: (
    title: string,
    description: string,
    children?: React.ReactNode
  ) => void;
}

const useDialogStore = create<DialogState>((set) => ({
  title: "",
  description: "",
  isOpen: false,
  openDialog: () => set({ isOpen: true }),
  closeDialog: () => set({ isOpen: false }),
  children: undefined,
  setChildren: (children) => set({ children }),
  setContent: (title, description, children) =>
    set({ title, description, children }),
}));

export { useDialogStore };
